import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BccTopCompetitors from './components/BccTopCompetitors';

const BccTopCompetitorsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Brand Category Competition - Top Competitors</h3>
      </Col>
    </Row>
    <Row>
      <BccTopCompetitors />
    </Row>
  </Container>
);

export default BccTopCompetitorsPage;
